import axios from "axios";

export let headers = {
	"Tenant-Access-Token": "Nzc3MzdiMjg1YzdlOWEwNzY1ZjUwZmVlYmQ2YTk0ODg=",
	"Tenant-Access-Key": "X98ZA7ZnUPqIWw",
};

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export const api = axios.create({
	baseURL: BASE_URL,
	headers,
});
